// utils/transactionStatus.js

export const getTransactionStatus = (status) => {
    let transactionStatus = '';
    let statusColor = '';
  
    switch (status) {
      case 1:
        transactionStatus = 'Processing';
        statusColor = 'warning'; // Default color for "Under Process"
        break;
      case 2:
        transactionStatus = 'Paid';
        statusColor = 'success'; // Green for "Paid"
        break;
      case 3:
        transactionStatus = 'Failed';
        statusColor = 'error'; // Red for "Failed"
        break;
      default:
        transactionStatus = 'Unknown';
        statusColor = 'default'; // Default color for unknown status
        break;
    }
  
    return { transactionStatus, statusColor };
  };
  